import { getAssetUrlInWorker } from '../getAssetUrl'

export default async ({
  editorSdkProxy,
  logger,
  shouldShowIllustration = true,
  illustration,
  helpId,
  headerText,
  topDescriptionText,
  bottomDescriptionText,
  mainActionText,
  secondaryActionText,
  onMainActionClick,
  onSecondaryActionClick,
  onCloseClick,
}) => {
  try {
    const panelResult = await editorSdkProxy.editor.openErrorPanel({
      shouldShowIllustration,
      illustration:
        illustration ||
        (await getAssetUrlInWorker(
          editorSdkProxy,
          'panel-icons/generic_trash.svg',
        )),
      helpId,
      headerText,
      topDescriptionText,
      bottomDescriptionText,
      mainActionText,
      secondaryActionText,
    })

    const actions = {
      mainActionClicked: onMainActionClick,
      secActionClicked: onSecondaryActionClick,
      closeActionClicked: onCloseClick,
    }

    const action = actions[panelResult]

    if (action) {
      await action()
    }
  } catch (error) {
    logger.error(new Error('Failed to open error panel', { cause: error }))
  }
}
